export default __webpack_public_path__ + "static/media/dragoge.79ed341b.webm";